import { useCallback } from 'react';
import { getLast } from '~/_shared/utils/array/array.helpers';
import type { ModalType } from '~/modal/modalType.enum';
import { useModalStackSelector } from '~/store/modal/modal.selectors';

export const useCheckModalOpen = () => {
  const modalStack = useModalStackSelector();

  const isModalOfTypeOpen = useCallback((modalType: ModalType) => {
    return getLast(modalStack)?.typeWithArgs[0] === modalType;
  }, [modalStack]);

  return {
    isModalOfTypeOpen,
  };
};
